import { render, staticRenderFns } from "./PackageService.vue?vue&type=template&id=3d5425b0&scoped=true"
import script from "./PackageService.vue?vue&type=script&lang=js"
export * from "./PackageService.vue?vue&type=script&lang=js"
import style0 from "./PackageService.vue?vue&type=style&index=0&id=3d5425b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5425b0",
  null
  
)

export default component.exports